import React, { useEffect } from 'react';
import premium from '../../assets/logo-assine.png';
import * as CryptoJS from 'crypto-js';
import { Container } from './styles';
import { useAuth } from '../../hooks/Auth';

const CardAssinatura: React.FC = () => {
    const { user } = useAuth();
    const [encrypted, setEncrypted] = React.useState('');

    // as chaves precisam estar igual no PHP
    function encryptPHP(data: string) {
        const KEY = 'f8d3c1a92b7e4f01'; // 16 caracteres
        const IV = 'a91c7f3e2b8d4c10';
        const key = CryptoJS.enc.Utf8.parse(KEY);
        const iv = CryptoJS.enc.Utf8.parse(IV);

        const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        });

        return encrypted.toString();
    }

    useEffect(() => {
        const result = encryptPHP(String(user.iduser));
        setEncrypted(result);
    }, []);

    return (
    <Container>
            <img src={premium} alt="assine" width={"35%"} />
            <span className="titulo">VERSÃO PREMIUM</span>
            <span className="subtitulo">APOIE NOSSO APP</span>
            <span className="destk">ADQUIRINDO A VERSÃO PREMIUM VOCÊ TERÁ AS SEGUINTES VANTAGENS:</span>
            <span className="vantagens">
                + App livre de propagandas<br/>
                + GERADOR DE PDF PARA IMPRESSÃO<br/>
                + NOTIFICAÇÃO PARA LEMBRAR DE ANOTAR<br/>
                + SEM LIMITE DE CASAIS NA LISTA DE 'ALUNOS'<br/>               
            </span>

            <div className="preco">
                <span className="mini">R$<br/>SÓ</span>
                <span className="valor">11,99</span>
                <span className="mini">AO<br/>MÊS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>

            <span className="destk2" style={{textTransform: 'uppercase', fontSize: '0.8rem'}}>Tão barato quando um lanche na padaria :)</span>
            
            
            <span className="caminho">INSTALE O APP, ACESSE A ÁREA RETIRAR PROPAGANDAS, E ENTÃO FAÇA SUA ASSINATURA, OU ASSINE VIA PIX.</span>

            <span>
                <a className="caminho"
                    style={{color: '#3fa69d', fontWeight: 'bold'}}
                    href={`https://metodobillings.com.br/checkoutpix.php?refer=${encodeURIComponent(encrypted)}`}
                    target="_blank"
                    rel="noreferrer">
                    PAGAR COM PIX
                </a>
            </span>
            
            <div style={{display: 'flex', gap:20, justifyContent: 'center', marginTop: 5}}>
                <a 
                className="botao" 
                rel="noreferrer" 
                href="https://play.google.com/store/apps/details?id=com.appmob" 
                target="_blank"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                    <path fill="currentColor" fill-rule="evenodd" d="M7.016 1.646a.5.5 0 0 1 .708 0l1.105 1.106A5.6 5.6 0 0 1 11.647 2h.706a5.6 5.6 0 0 1 2.82.753l1.107-1.107a.5.5 0 1 1 .707.708l-.984.984A5.64 5.64 0 0 1 18 7.648a.353.353 0 0 1-.353.352H6.353A.353.353 0 0 1 6 7.647c0-1.728.776-3.275 2-4.31l-.984-.983a.5.5 0 0 1 0-.708M10.5 5.25a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m3.724.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5" clip-rule="evenodd"/><path fill="currentColor" d="M4 8.947a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m3 0a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zm12.21 1a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0zM7.793 21a.293.293 0 0 0-.293.294v.206a1.75 1.75 0 1 0 3.5 0v-.206a.293.293 0 0 0-.293-.294zm5.207.294c0-.163.131-.294.293-.294h2.913c.163 0 .294.131.294.294v.206a1.75 1.75 0 1 1-3.5 0z"/>
                    </svg>
                </a>
                <a 
                className="botao" 
                rel="noreferrer" 
                href="https://apps.apple.com/us/app/mob-m%C3%A9todo-ovula%C3%A7%C3%A3o-billings/id6760237301" 
                target="_blank"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M17.05 20.28c-.98.95-2.05.8-3.08.35c-1.09-.46-2.09-.48-3.24 0c-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8c1.18-.24 2.31-.93 3.57-.84c1.51.12 2.65.72 3.4 1.8c-3.12 1.87-2.38 5.98.48 7.13c-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25c.29 2.58-2.34 4.5-3.74 4.25"/>
                    </svg>
                </a>
            </div>
            

  </Container>  
  );
}

export default CardAssinatura;